import { useGridApiRef } from '@chronosphereio/chrono-ui';
import constate from 'constate';

function useDataTableAPIInternal() {
  const ref = useGridApiRef();
  return {
    ref,
  };
}

const [
  /**
   * Provider for the DataTable API. Use this if you need access to the DataTable API in context.
   */
  DataTableAPIProvider,
  useDataTableAPIStrict,
] = constate(useDataTableAPIInternal);

function useDataTableAPIContext() {
  try {
    return useDataTableAPIStrict();
  } catch (_e) {
    return null;
  }
}

export function useDataTableAPIRef() {
  return useDataTableAPIContext()?.ref;
}

/**
 * Hook to get the DataTable API, if available.
 */
export function useDataTableAPI() {
  return useDataTableAPIRef()?.current;
}

export { DataTableAPIProvider };
